export enum PropertyCategory {
  PRIMARY = "primary",
  SECONDARY_BUY = "secondary_buy",
  SECONDARY_RENTAL = "secondary_rent",
  COMMERCIAL_BUY = "commercial_buy",
  COMMERCIAL_RENTAL = "commercial_rent",
  PROJECT = "project",
  LAND = "land",
}
